import toVirtualDom from 'to-virtual-dom'

function htmlStringToVueDom(createElement, htmlString, componentReference, converter) {
	const tree = toVirtualDom(htmlString)
	return createChildDom(tree, createElement, componentReference, converter)
}

function sanitize(text){
	let textToReturn = text
	textToReturn = textToReturn.replace(/&nbsp;/g, " ")
	textToReturn = textToReturn.replace(/&lt;/g, "<")
	textToReturn = textToReturn.replace(/&gt;/g, ">")
	textToReturn = textToReturn.replace(/&quot;/g, "\"")
	textToReturn = textToReturn.replace(/&apos;/g, "'")
	textToReturn = textToReturn.replace(/&cent;/g, "¢")
	textToReturn = textToReturn.replace(/&pound;/g, "£")
	textToReturn = textToReturn.replace(/&yen;/g, "¥")
	textToReturn = textToReturn.replace(/&euro;/g, "€")
	textToReturn = textToReturn.replace(/&copy;/g, "©")
	textToReturn = textToReturn.replace(/&reg;/g, "®")
	textToReturn = textToReturn.replace(/&amp;/g, "&")
	return textToReturn
}

function createChildDom(tree, createElement, componentReference, converter) {
	if (tree.constructor.name == "VirtualText" || (!tree.children && tree.text)) {
		let textToReturn = tree.text	
		return sanitize(textToReturn)
	}
	
	let newChildren
	try{
		newChildren = tree.children.map(child => {
			return createChildDom(child, createElement, componentReference, converter)
		})
	}
	catch(error){
		// newChildren = undefined
		return
	}
	const properties = Object.assign({}, tree.properties)
	let attrs = Object.assign({}, tree.properties)
	const defaults = ['style', 'className', 'key', 'ref', 'refInFor', 'slot', 'v-on:click', 'href', 'src', 'dataset']
	let on = {}
	let style = {}
	for (const key of defaults) {
		switch (key) {
			case 'href': 
				if (attrs.href){
					attrs.href = sanitize(attrs.href)
				}
				break;
			case 'src': 
				if (attrs.src){
					attrs.src = sanitize(attrs.src)
				}
				break;
			case 'className':
				if (attrs.className) {
					attrs.class = attrs.className
				}
				break
			case 'style':
				if (attrs.style) {
					attrs.style = Object.entries(attrs.style).map(value => {
						style[value[0]] = value[1]
					})
				}
			case 'dataset':
				if (attrs.dataset) {
					for(let value in attrs.dataset) {
						attrs[`data-${value}`] = attrs.dataset[value]
					}
				}
			case 'v-on:click':
				if (attrs['v-on:click']) {
					on = {click: function(event){
						try{
							const regex = /goToAnchor\(\d+\)/
							const matches = regex.exec(attrs['v-on:click']);
							eval(`componentReference.${matches[0]}`)
						}catch (e) {
							console.error(e.message)
						}

					}}
				}
				break
		}
	}
	attrs.dataset = null
	const newElement = createElement(tree.tagName.toLowerCase(), {attrs, style, on}, newChildren)
	if (converter) {
		return converter(newElement)
	}
	return newElement

}

export default htmlStringToVueDom